const newsRouter = [
  {
    path: "list-news",
    name: "list",
    component: () => import("@/views/admin/news"),
    default: true,
    meta: {
      model: "news",
      // requiresAuth: true,
    },
  },
  {
    path: "list-news/add",
    name: "add",
    component: () => import("@/views/admin/news/function"),
    default: true,
    meta: {
      model: "news",
      // requiresAuth: true,
    },
  },
  {
    path: "list-news/edit/:id",
    name: "edit",
    component: () => import("@/views/admin/news/function"),
    default: true,
    meta: {
      model: "news",
      // requiresAuth: true,
    },
  },
  {
    path: "list-news/add_promotion",
    name: "add_promotion",
    component: () => import("@/views/admin/news/function_promotion"),
    default: true,
    meta: {
      model: "news",
      // requiresAuth: true,
    },
  },
  {
    path: "list-news/edit_promotion/:id",
    name: "edit_promotion",
    component: () => import("@/views/admin/news/function_promotion"),
    default: true,
    meta: {
      model: "news",
      // requiresAuth: true,
    },
  },
];
export default newsRouter;
